module.exports = __webpack_public_path__ + "static/media/manage_staff.bad2829d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/components/manage_staff.svg
// module id = 1811
// module chunks = 0